(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_071d904"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('eu-withdrawal')) return;

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    class EUWithdrawal extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.titleEl = this.querySelector('[data-euw-title]');
        this.footer = this.querySelector('[data-euw-footer]');
        this.backBtn = this.querySelector('[data-euw-back]');
        this.nextBtn = this.querySelector('[data-euw-next]');
        this.steps = this.querySelectorAll('[data-step]');
        try {
          this.labels = JSON.parse(this.querySelector('[data-euw-labels]').textContent);
        } catch (e) {
          this.labels = {};
        }
        this.step = 1;

        this.querySelector('[data-euw-open]').addEventListener('click', () => this.open());
        this.querySelectorAll('[data-euw-close]').forEach((b) =>
          b.addEventListener('click', () => this.dialog.close())
        );
        this.backBtn.addEventListener('click', () => this.onBack());
        this.nextBtn.addEventListener('click', () => this.onNext());

        // Click on backdrop closes
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.dialog.close();
        });
        // Esc (native) or any close → reset
        this.dialog.addEventListener('close', () => this.onClose());

        if (this.form) {
          this.form.addEventListener('submit', (e) => {
            if (!this.validate()) {
              e.preventDefault();
              return;
            }
            this.nextBtn.disabled = true;
          });
          this.form.querySelectorAll('[data-euw-field]').forEach((input) =>
            input.addEventListener('input', () => this.clearError(input))
          );
        }

        // After Shopify redirects back from /contact
        if (this.querySelector('[data-euw-posted]')) {
          this.open();
          this.goTo(3);
        } else if (this.querySelector('[data-euw-server-errors]')) {
          this.open();
          this.goTo(2);
        }
      }

      open() {
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }

      onClose() {
        document.documentElement.style.overflow = '';
        this.nextBtn.disabled = false;
        if (this.form) this.form.reset();
        this.clearAllErrors();
        const serverErrors = this.querySelector('[data-euw-server-errors]');
        if (serverErrors) serverErrors.remove();
        const posted = this.querySelector('[data-euw-posted]');
        if (posted) posted.remove();
        this.goTo(1);
      }

      onBack() {
        if (this.step === 2) this.goTo(1);
        else this.dialog.close();
      }

      onNext() {
        if (this.step === 1) this.goTo(2);
        else if (this.step === 2 && this.form) {
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else if (this.validate()) {
            this.nextBtn.disabled = true;
            this.form.submit();
          }
        }
      }

      goTo(n) {
        this.step = n;
        this.steps.forEach((el) => el.classList.toggle('is-active', Number(el.dataset.step) === n));

        const L = this.labels;
        if (n === 1) {
          this.titleEl.textContent = L.step1Title || '';
          this.backBtn.textContent = L.cancel || '';
          this.nextBtn.textContent = L.continue || '';
          this.footer.hidden = false;
        } else if (n === 2) {
          this.titleEl.textContent = L.step2Title || '';
          this.backBtn.textContent = L.back || '';
          this.nextBtn.textContent = L.submit || '';
          this.footer.hidden = false;
          const first = this.querySelector('[data-euw-field="name"]');
          if (first) setTimeout(() => first.focus(), 50);
        } else {
          this.titleEl.textContent = L.successTitle || '';
          this.footer.hidden = true;
        }
      }

      validate() {
        this.clearAllErrors();
        let firstInvalid = null;
        this.form.querySelectorAll('[data-euw-field]').forEach((input) => {
          const v = input.value.trim();
          const bad = !v || (input.type === 'email' && !EMAIL_RE.test(v));
          if (bad) {
            this.showError(input);
            if (!firstInvalid) firstInvalid = input;
          }
        });
        if (firstInvalid) firstInvalid.focus();
        return !firstInvalid;
      }

      showError(input) {
        const err = this.querySelector(`[data-error="${input.dataset.euwField}"]`);
        input.setAttribute('aria-invalid', 'true');
        if (err) {
          err.classList.add('is-active');
          input.setAttribute('aria-describedby', err.id);
        }
      }

      clearError(input) {
        const err = this.querySelector(`[data-error="${input.dataset.euwField}"]`);
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (err) err.classList.remove('is-active');
      }

      clearAllErrors() {
        if (!this.form) return;
        this.form.querySelectorAll('[data-euw-field]').forEach((i) => this.clearError(i));
      }
    }

    customElements.define('eu-withdrawal', EUWithdrawal);
  })();
  } catch(e) { console.error(e); }
})();

})();
